import {
  ClientsRouteSkeleton,
  DashboardRouteSkeleton,
  InventoriesRouteSkeleton,
  OrdersPurchasesRouteSkeleton,
  OrdersSalesRouteSkeleton,
  ProductsRouteSkeleton,
  ProvidersRouteSkeleton,
  TerminalsRouteSkeleton,
  TerminalsIdRouteSkeleton,
  DeliveriesRouteSkeleton,
} from "~/components/route-skeletons";
import type { Terminal } from "../db/schema";

function getRoutePrefix(pathname: string): string {
  // Remove query parameters
  const path = pathname.split("?")[0];

  // Check for route prefixes
  if (path === "/dashboard") return "dashboard";

  if (path.startsWith("/clients")) return "clients";
  if (path.startsWith("/orders/purchases")) return "orders/purchase";
  if (path.startsWith("/orders/sales")) return "orders/sales";
  if (path.startsWith("/products")) return "products";
  if (path.startsWith("/providers")) return "providers";
  if (path.startsWith("/inventories")) return "inventories";

  if (path === "/terminals") return "terminals";

  if (path.startsWith("/terminals/")) return "terminals/id";
  // if (path.startsWith("/terminals/") && path.endsWith("/inflows"))
  //   return "terminals/id/inflows";
  // if (path.startsWith("/terminals/") && path.endsWith("/outflows"))
  //   return "terminals/id/outflows";

  if (path.startsWith("/prices")) return "prices";
  if (path.startsWith("/deliveries")) return "deliveries";

  return "default";
}

// Create a wrapper component that safely uses hooks and passes data to the skeleton
function RouteSkeletonRenderer({
  pathname,
  terminals,
}: {
  pathname: string;
  terminals: Terminal[];
}) {
  // Find terminal ID if we're on a terminal route
  const terminalId = pathname.startsWith("/terminals/")
    ? pathname.split("/terminals/")[1]?.split("/")[0]
    : null;

  const terminal = terminalId
    ? (terminals?.find((t) => t.id === terminalId) as Terminal)
    : undefined;

  const routePrefix = getRoutePrefix(pathname);

  // Render the appropriate skeleton based on route
  switch (routePrefix) {
    case "dashboard":
      return <DashboardRouteSkeleton />;

    case "clients":
      return <ClientsRouteSkeleton />;

    case "orders/purchase":
      return <OrdersPurchasesRouteSkeleton />;

    case "orders/sales":
      return <OrdersSalesRouteSkeleton />;

    case "products":
      return <ProductsRouteSkeleton />;

    case "providers":
      return <ProvidersRouteSkeleton />;

    case "inventories":
      return <InventoriesRouteSkeleton />;

    case "terminals":
      return <TerminalsRouteSkeleton />;

    case "terminals/id":
      return terminal ? <TerminalsIdRouteSkeleton terminal={terminal} /> : null;

    case "deliveries":
      return <DeliveriesRouteSkeleton />;

    default:
      return null;
  }
}

export function getRouteSkeleton(
  pathname: string,
  terminals: Terminal[] = []
): React.ReactNode {
  return <RouteSkeletonRenderer pathname={pathname} terminals={terminals} />;
}
